<template>
  <div class="drag-node">
    <!-- 输入框 -->
    <div v-if="itemData.nodeType ==1" @click="clickNode(itemData)">
      <div class="self-button">
        {{itemData.fieldName}}
      </div>
    </div>
    <!-- 输出|| 文本类型 -->
    <div class="nodeBox" v-if="itemData.nodeType == 2" @mouseover="mouseOver(itemData)"
      @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
      <div class="selfOut ">
        {{getName(itemData.outputType)}} {{itemData.displayContent}}
      </div>
      <div class="outHover" v-if="hoverId == itemData.id">
        <div v-if="itemData.executedRemark">{{itemData.executedRemark}}</div>
        <div v-else>
          <div v-if="itemData.outputType=='4'">
            {{  }}
            【{{itemData.itemName}}】【{{itemData.cycleStr ? itemData.cycleStr : transCycle(itemData.cycle)}}】【{{itemData.attrs}}】<br />
            <span v-if="itemData.useDosageName">【{{itemData.useDosageName}}】<br /></span>
            【{{itemData.startTimeType}}【{{itemData.startIntervalTime}}】
          </div>
          <div v-else>
            {{itemData.displayContent}}
          </div>
        </div>

      </div>
    </div>
    <!-- 条件类型 -->
    <div v-if="itemData.nodeType == 3">
      <!-- 时间 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 1" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{itemData.value}}</div>
          <div>{{handleHourlyBasis(itemData.valueUnit)}}</div>
          <div>{{handleAroundBasis(itemData.operator)}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 定量 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 2" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <!-- <div class='bg-diamond'></div> -->
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{handelSymbolArr(itemData.operator)}}</div>
          <div>{{itemData.value}}</div>
          <div>{{handleQualitative(itemData.valueUnit)}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 定性 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 3" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{itemData.value}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 绝对 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 4" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{handelAbsoluteType(itemData.operator)}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 最后次数 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 5" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{itemData.operator}}</div>
          <div>{{itemData.value}}</div>
          <div>{{itemData.valueUnit}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 间隔次数 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 6" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{handelSymbolArr(itemData.operator)}}</div>
          <div>{{itemData.value}}</div>
          <div>{{itemData.valueUnit}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 持续时间 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 7" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{itemData.value}}</div>
          <div>{{handleHourlyBasis(itemData.valueUnit)}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
      <!-- 问卷分值 -->
      <div class="selfDomImg" v-if="itemData.conditionType == 8" @mouseover="mouseOver(itemData)"
        @mouseleave="mouseLeave(itemData)" @click="clickNode(itemData)">
        <img class="nodeImg" v-if="itemData.img" :src="imgSrc1" alt="">
        <img class="nodeImg" v-else :src="imgSrc" alt="">
        <div class="nodeCon">
          <div>{{handelSymbolArr(itemData.operator)}}</div>
          <div>{{itemData.value}}</div>
          <div>{{handelNumArr(itemData.valueUnit)}}</div>
        </div>
        <div class="outHover" v-if="hoverId == itemData.id && itemData.executedRemark">{{itemData.executedRemark}}</div>
      </div>
    </div>
    <!-- 通知类型 -->
    <div class="nodeBox" v-if="itemData.nodeType == 4" @click="clickNode(itemData)">
      <div class="selfMess">
        <div>全病程房间</div>
        <div>{{itemData.showCon}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { transCycle } from "../js/handle.js";
export default {
  name: "drag-node",
  props: {
    itemData: {
      type: Object
    }
  },
  data() {
    return {
      imgSrc1: require("./off.png"),
      imgSrc: require("./on.png"),
      hoverId: null
    };
  },
  methods: {
    transCycle: transCycle,
    clickNode(item) {
      // item.value = "获取值";
      this.$emit("clickNode", item);
    },
    changeSelect(val) {
    },
    // mouseOver(id) {
    //   this.houverId = id;
    // },
    mouseOver(item) {
      item.img = false;
      this.hoverId = item.id;
    },
    mouseLeave(item) {
      item.img = true;
      this.hoverId = null;
    },
    getName(val) {
      if (val == "1") {
        return "文本:";
      } else if (val == "2") {
        return "问卷:";
      } else if (val == "3") {
        return "宣教:";
      } else if (val == "4") {
        return "编链:";
      }
    },
    handleHourlyBasis(val) {
      if (val == "1") {
        return "秒";
      } else if (val == "2") {
        return "分";
      } else if (val == "3") {
        return "时";
      } else if (val == "4") {
        return "日";
      } else if (val == "5") {
        return "周";
      } else if (val == "6") {
        return "月";
      } else if (val == "7") {
        return "年";
      }
    },
    handleAroundBasis(val) {
      if (val == "1") {
        return "后";
      } else if (val == "2") {
        return "内";
      } else if (val == "4") {
        return "前";
      }
    },
    handleQualitative(val) {
      if (val == "1") {
        return "秒";
      } else if (val == "2") {
        return "分";
      } else if (val == "3") {
        return "时";
      } else if (val == "4") {
        return "日";
      } else if (val == "5") {
        return "周";
      } else if (val == "6") {
        return "月";
      } else if (val == "7") {
        return "年";
      } else if (val == "8") {
        return "毫升";
      } else if (val == "9") {
        return "升";
      } else if (val == "10") {
        return "毫米";
      } else if (val == "11") {
        return "厘米";
      } else if (val == "12") {
        return "分米";
      } else if (val == "13") {
        return "米";
      } else if (val == "14") {
        return "千米";
      } else if (val == "15") {
        return "mmol/L";
      } else if (val == "16") {
        return "岁";
      } else if (val == "17") {
        return " ";
      }
    },
    handelSymbolArr(val) {
      if (val == "1") {
        return ">";
      } else if (val == "2") {
        return "≥";
      } else if (val == "3") {
        return "=";
      } else if (val == "4") {
        return "<";
      } else if (val == "5") {
        return "≤";
      } else if (val == "6") {
        return "≠";
      }
    },
    handelAbsoluteType(val) {
      if (val == "3") {
        return "是";
      } else if (val == "6") {
        return "否";
      } else if (val == "7") {
        return "不确定";
      }
    },
    handelNumArr(val) {
      if (val == "1") {
        return "分";
      }
    }
  },

  created() {
    // debugger
  }
};
</script> 
<style scoped>
.selfMess {
  padding: 12px;
  border: solid 2px rgb(228, 226, 226);
  cursor: move;
  text-align: center;
  border-radius: 6px;
}
.selfOut {
  width: 120px;
  border-radius: 6px;
  padding: 5px 8px;
  height: 30px;
  text-align: center;
  border: solid 2px rgb(228, 226, 226);
  cursor: move;
  background: #f0f0f0;
  position: relative;
  overflow: hidden;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.outHover {
  position: absolute;
  width: 220px;
  min-height: 32px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  color: #fff;
  left: -50px;
  top: 30px;
  padding: 4px;
  z-index: 999;
  font-size: 12px;
}
.selfDomImg .outHover {
  top: -31px;
  left: 10px;
}
.self-button {
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 14px;
  border: solid 2px rgb(228, 226, 226);
  cursor: move;
  max-height: 32px;
  white-space: nowrap;
}
.right-select {
  top: 63px;
  width: 60px;
  height: 30px;
  position: absolute;
  right: 0;
}
.selfDomImg {
  width: 148px;
  height: 94px;
  position: relative;
}
.selfDomImg:hover {
  cursor: move;
}
.bg-diamond {
  width: 110px;
  height: 110px;
  border: solid 2px rgb(228, 226, 226);
  transform: rotate(45deg) translate(40px, -8px);
}
.bg-diamond:hover,
.self-button:hover,
.selfMess:hover,
.selfOut:hover {
  border-color: #e9f2ff;
  background: #e9f2ff;
}
.left-input {
  width: 40px;
  height: 30px;
  position: absolute;
  left: 0;
  top: 63px;
}
.nodeBox {
  position: relative;
}
.nodeHover {
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: absolute;
  top: -20px;
  right: -40px;
  border-radius: 5px;
  padding: 5px;
}

.nodeImg {
  width: 148px;
  height: 94px;
}
.nodeCon {
  position: absolute;
  width: 100%;
  top: 0;
  text-align: center;
}

.nodeCon div {
  display: inline-block;
  min-width: 25px;
  text-align: center;
  line-height: 92px;
}
.nodeConTest {
  position: absolute;
  width: 100%;
  margin-top: 63px;
  top: 0;
  text-align: center;
}
.nodeConTest div {
  display: inline-block;
  padding: 0 8px;
  min-width: 30px;
  max-width: 40px;
  border: solid 1px gray;
  text-align: center;
  line-height: 30px;
  height: 30px;
  overflow: hidden;
  margin-left: 8px;
  border-radius: 4px;
  background: #fff;
}
</style>
